export class ListItem {
  picture_icon: string;
  picture_ava: string;
  picture_preview: string;
  itemFullData: object;

  type: string;
  icon: string;
  name: string;
  filter_string: string;
  full_path_old: string;
  full_path: string;
  owner: string;
  users: Array<string>;
  cdateFormatted: string;
  size: number;
  cdate: number;
  mdate: number;
  ext: string = '';
  isSnapshot = false;
  isSelected = false;
  isInFocus = false;
  isPending = false;
  isError = false;
  animateAndFocus = false;
  jobID: string; // background job UUID
  jobNextAction: string; // e.g. 'delete' if delete job successes
  get isClientOrFriend(): boolean {
    return this.isClient || this.isFriend
  }
  get showWarning(): boolean {
    return (this.isClient) && (this.itemFullData['ack_tcs'] != 'Y' || this.itemFullData['ack_privacy'] != 'Y');
  }
  get isClient(): boolean {
    return this.type === 'client'
  }
  get isFriend(): boolean {
    return this.type === 'friend' || this.type === 'my_friend_referral'
  }
  get isMyReferral(): boolean {
    return this.type === 'my_referral'
  }
  get isMyFriendReferral(): boolean {
    return this.type === 'my_friend_referral'
  }
  get isTrainer(): boolean {
    return this.type === 'trainer'
  }
  get isDirectory(): boolean {
    return this.type === 'd'
  }
  get isStorage(): boolean {
    return this.type === 'b'
  }
  get isShared(): boolean {
    return this.type === 's'
  }
  get isFile(): boolean {
    return this.type === 'f'
  }
  get isNotAccessible(): boolean {
    return this.isPending || this.isError
  }
  static genItem({ name, type, time, size, path, icon, ava, preview, filter_string, data }): ListItem {
    const listingItem = new ListItem()
    listingItem.picture_icon = icon;
    listingItem.picture_ava = ava;
    listingItem.picture_preview = preview;
    listingItem.itemFullData = data;
    listingItem.name = name;
    listingItem.type = type;
    listingItem.size = size;
    listingItem.full_path = path;
    listingItem.filter_string = filter_string;
    listingItem.cdate = time;
    return listingItem
  }

  //articleDTO.article parsers
  static getFrontBannerSrcF = function (content: Object[]): string {
    for (let i = 0; i < content.length; i++) {
      let model = content[i];
      if(model['type'] == 'image' && model['image_url']) {
        return model['image_url']
      }
    }
    return '';
  }
  static getVideoUrl = function (content: Object[]): string {
    for (let i = 0; i < content.length; i++) {
      let model = content[i];
      if(model['type'] == 'image' && model['video_url']) {
        return model['video_url']
      }
    }
    return '';
  }
  static getFrontTitle = function (content: Object[]): string {
    for (let i = 0; i < content.length; i++) {
      var model = content[i];
      if(model['type'] == 'image' && model['caption']) {
        return model['caption']
      }
      if(model['type'] == 'title' && model['value']) {
        return model['value']
      }
    }
    return '';
  }

}
